import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { getFullShipToAddress } from '@epicuro-next/utilities';

import { InboundDetailsComponentStore } from './inbound-details.component-store';

@Component({
  selector: 'epc-inbound-details',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './inbound-details.component.html',
  styleUrls: ['./inbound-details.component.scss'],
  standalone: false,
})
export class InboundDetailsComponent {
  public readonly hasItems$ = this.componentStore.hasItems$;
  public readonly inboundHistory$ = this.componentStore.inboundHistory$;
  public readonly deliveredHistory$ = this.componentStore.deliveredHistory$;
  public readonly loading$ = this.componentStore.loading$;
  public readonly locale$ = this.componentStore.locale$;
  public readonly dateFormat = 'MMM d, yyyy';

  public readonly getFullShipToAddress = getFullShipToAddress;

  @Input()
  public showDetails = false;

  @Output()
  public toggleView = new EventEmitter<boolean>();

  constructor(private componentStore: InboundDetailsComponentStore) {}

  public handleClose(open: boolean) {
    this.toggleView.emit(open);
    this.showDetails = open;
  }
}
